import { AnalyticsEvent } from '../models';

export class BagPageLoadEvent implements AnalyticsEvent {
  name = 'BagPageLoadEvent';
}